module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE1IDEyIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjQxIDBMNC4zOTcgOC44OTVsLTIuODM3LTIuOEwwIDcuNjM1bDMuNzQ0IDMuNjk1LjAwNC0uMDA0LjY4My42NzRMMTUgMS41N3oiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/check-thin.svg
// module id = 29
// module chunks = 0